import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "invoices";

export const postInvoiceAsync = async (id) => {
  return await http.put(`${apiEndpoint}/${id}`);
};

export const voidInvoiceAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/${id}`);
};

export const sendInvoiceAsync = async (id) => {
  return await http.post(`${apiEndpoint}/mail/${id}`);
};

export const generateAccountInvoicesAsync = async (id) => {
  return await http.post(`${apiEndpoint}/accounts/${id}`);
};

export const getInvoiceInformationAsync = async (id) => {
  return await http.get(`${apiEndpoint}/${id}`);
};

export const getInvoicesAsync = async (params) => {
  const {
    sort_column,
    status,
    posted,
    year,
    month,
    date,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}?q=${query}&status=${status}&posted=${posted}&year=${year}&month=${month}&date=${date}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountInvoicesAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/accounts/${id}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountUnpaidInvoicesAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/accounts/unpaid/${id}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getInvoiceStatuses = () => {
  return [
    { label: "Paid", value: true },
    { label: "Unpaid", value: false },
  ];
};

export const getInvoicePostings = () => {
  return [
    { label: "Posted", value: true },
    { label: "Unposted", value: false },
  ];
};

export const invoiceService = {
  postInvoiceAsync,
  voidInvoiceAsync,
  sendInvoiceAsync,
  generateAccountInvoicesAsync,
  getInvoicesAsync,
  getInvoiceStatuses,
  getInvoicePostings,
  getAccountInvoicesAsync,
  getAccountUnpaidInvoicesAsync,
};

export default invoiceService;
